(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc router
     *@name router
     *@description
     *Router
     */

    angular
        .module('app')
        .config(function ($routeProvider, $locationProvider) {
          $locationProvider.hashPrefix('');

          $routeProvider
            .when('/:lang', {
               // templateUrl : 'pages/home.html',
                //controller  : 'AppController'
            })            
            .when('/:lang/projecte', {
                templateUrl : 'static/app/views/project.html',
                controller  : 'ProjectController',
                controllerAs: 'pt',
                resolve: {
                   pagina: function(paginaService){
                      return paginaService.getPagina('projecte');
                  }
                }
            })
            .when('/:lang/contacte', {
                templateUrl : 'static/app/views/contacte.html',
                controller  : 'ContacteController',
                controllerAs: 'co',
                resolve: {
                   pagina: function(paginaService){
                      return paginaService.getPagina('contacte');
                  }
                }
            })
            .when('/:lang/avis-legal', {
                templateUrl : 'static/app/views/avis-legal.html',
                controller  : 'AvisLegalController',
                controllerAs: 'al',
                resolve: {
                   pagina: function(paginaService){
                      return paginaService.getPagina('avis-legal');
                  }
                }
            }).when('/:lang/accedir', {
                templateUrl : 'static/app/views/login.html',
                controller  : 'LoginController',
                controllerAs: 'lg',
                auth:false

            }).when('/:lang/recuperar-contrasenya', {
                templateUrl : 'static/app/views/recuperar.html',
                controller  : 'LoginController',
                controllerAs: 'lg',
                auth:false

            }).when('/:lang/recuperar-contrasenya/:token', {
                templateUrl : 'static/app/views/setPassword.html',
                controller  : 'LoginController',
                controllerAs: 'lg',
                auth:false

            }).when('/:lang/favorits', {
                templateUrl : 'static/app/views/favorits.html',
                controller  : 'FavoritsController',
                controllerAs: 'fc',
                auth:true
            }).when('/:lang/usuari', {
                templateUrl : 'static/app/views/usuari.html',
                controller  : 'UsuariController',
                controllerAs: 'uc',
                auth:true
            }).when('/:lang/logout', {
                template:'',
                controller  : 'LogoutController',
                controllerAs: 'lgc',

            }).when('/:lang/registre', {
                templateUrl : 'static/app/views/registre.html',
                controller  : 'RegistreController',
                controllerAs: 'rc',
            }).when('/:lang/recursos', {
                templateUrl : 'static/app/views/experiencies.html',
                controller  : 'ExperienciesController',
                controllerAs: 'ec',
            }).when('/:lang/autor/:autor', {
                templateUrl : 'static/app/views/autor.html',
                controller  : 'AutorController',
                controllerAs: 'ac',
                resolve: {
                   pagina: function(espaiService){
                      return espaiService.resolve();
                  }
                }
            })
            .when('/:lang/centre/:centre', {
                templateUrl : 'static/app/views/autor.html',
                controller  : 'AutorController',
                controllerAs: 'ac',
                resolve: {
                   pagina: function(espaiService){
                      return espaiService.resolve();
                  }
                }
            }).when('/:lang/espai/:centre', {
                templateUrl : 'static/app/views/autor.html',
                controller  : 'AutorController',
                controllerAs: 'ac',
                resolve: {
                   pagina: function(espaiService){
                      return espaiService.resolve();
                  }
                }
            }).when('/:lang/espai/:centre/:ruta', {
                templateUrl : 'static/app/views/autor.html',
                controller  : 'AutorController',
                controllerAs: 'ac',
                resolve: {
                   pagina: function(espaiService){
                      return espaiService.resolve();
                  }
                }
            });

            /* route for the contact page
            .when('/:lang/contact', {
                templateUrl : 'pages/contact.html',
                controller  : 'contactController'
            });*/

            $locationProvider.html5Mode(true);

        });


})();